import { Card, Stack, Typography } from "@mui/material";
import { capitalized } from "../helpers/strings";

const OrderCard = ({order}) => {

    return <Card>
        <Stack direction="column" sx={{margin: 2}}>
            <Typography variant="h2">Order {order.order_id}</Typography>
            <Typography variant="h4" sx={{marginBottom: 1}}>{capitalized(order.status)}</Typography>
            <Typography variant="p">{order.recipient_name}</Typography>
            <Typography variant="p">{order.address}<br />{order.city}, {order.state} ({order.country})</Typography>
            <Typography variant="h3">{order.comments !== "" ? "Notes: " + order.comments : ""}</Typography>
        </Stack>
    </Card>;
};



export { OrderCard };